<template>
  <div class="manual-review-grid-cell">
    <div
      v-if="title"
      class="cell-title"
    >
      <slot name="title" />
    </div>

    <div class="cell-body">
      <div class="cell-list">
        <div
          v-for="(item, index) in items"
          :key="index"
          class="list-item"
        >
          <div class="item-description">
            <span
              v-if="index > 0"
              class="or-text"
            >
              OR
            </span>
            {{ item }}
          </div>
        </div>

        <!-- Fallback to slot if no items prop -->
        <slot
          v-if="!items.length"
          name="items"
        />
      </div>
    </div>
  </div>
</template>

<script setup>
// Props for grid positioning if needed
defineProps({
  items: {
    type: Array,
    default: () => [],
  },
});
</script>

<style scoped lang="scss">
.manual-review-grid-cell {
  display: flex;
  min-height: 127px;
  height: 100%;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  flex-shrink: 0;
  align-self: stretch;

  .cell-title {
    display: flex;
    height: 19px;
    align-items: center;
    gap: 8px;
    flex-shrink: 0;
    align-self: stretch;
    font-weight: bold;
  }

  .cell-body {
    display: flex;
    width: 100%;
    padding: 20px;
    box-sizing: border-box;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    gap: 12px;
    border-radius: 30px;
    border: 1px solid var(--Constant-Status-Yield, #faa542);
    background: var(--opacities-status-yield-15, rgba(250, 165, 66, 0.15));
    box-shadow: 0px 5px 20px 0px rgba(0, 0, 0, 0.05);
    backdrop-filter: blur(13px);

    .cell-list {
      display: flex;
      flex-direction: column;
      gap: 12px;
      width: 100%;

      .list-item {
        display: flex;
        width: 100%;
        max-width: 170px;
        height: 32px;
        align-items: center;

        .item-description {
          flex: 1 0 0;
          font-size: 14px;
          line-height: 1.4;

          .or-text {
            font-weight: bold;
            font-style: italic;
          }
        }
      }
    }
  }
}
</style>
